import { useEffect } from 'react';
import { getDocument } from 'utilities/window.js';
import { ILoadPageResult } from './layout-build-types.js';

const metaUpdate = (queryProperty: string, value: string, insert: 'ADD' | 'REMOVE') => {
  // Get an element if it exists already
  const element = getDocument()?.querySelector(`meta[${queryProperty}]`);
  if (insert === 'ADD') {
    if (element) {
      // If it does just change the content of the element
      element.setAttribute('content', value);
    } else {
      // It doesn't exist so lets make a HTML element string with the info we want
      const el = `<meta ${queryProperty} content="${value}" />`;
      // And insert it into the head
      getDocument()?.head.insertAdjacentHTML('afterbegin', el);
    }
  }
  if (insert === 'REMOVE' && element) {
    // If it does just remove the element
    element.remove();
  }
};

export const getIs4xx = (code: number): boolean => {
  const is404 = code >= 400 && code < 500;
  return is404;
};

export const LayoutErrorHelmetHook = ({ res }: { res: ILoadPageResult }): void => {
  useEffect(() => {
    const is404 = (!res.layoutLoadSuccess && getIs4xx(res.error.code)) ?? false;
    metaUpdate('name="prerender-status-code"', '404', is404 ? 'ADD' : 'REMOVE');
    return () => {
      metaUpdate('name="prerender-status-code"', '404', 'REMOVE');
    };
  }, [res]);
};
